(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9323],{

/***/ 59323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Footer002": function() { return /* binding */ Footer002; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51712);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87900);
/* harmony import */ var _Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14806);
/* harmony import */ var _Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var Footer002 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var manager = (ref1 = payload === null || payload === void 0 ? void 0 : payload.manager) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    var formType = (ref2 = payload === null || payload === void 0 ? void 0 : payload.formType) !== null && ref2 !== void 0 ? ref2 : {};
    var ref3;
    var template = (ref3 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref3 !== void 0 ? ref3 : "dark";
    var fullName = manager.fullName, position = manager.position, contactTitle = manager.contactTitle, contactValue = manager.contactValue;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("002", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.FOOTER */ .R.FOOTER);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Footer__WEBPACK_IMPORTED_MODULE_1__/* .FooterWidgetWrapper */ .b, {
        className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[template],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Heading3 */ .aC, {
                    className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                    color: "dark",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blocks),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().manager),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .ImageLite */ .NH, {
                                    image: manager.preview,
                                    className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().info),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                                            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
                                            color: "dark",
                                            appearance: "bold",
                                            children: fullName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                                            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().position),
                                            color: "grey",
                                            uppercase: true,
                                            children: position
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                                            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                            color: "grey",
                                            uppercase: true,
                                            children: contactTitle
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "tel:".concat(contactValue),
                                            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().phone),
                                            children: contactValue
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Footer002_module_scss__WEBPACK_IMPORTED_MODULE_6___default().application),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                item: formType,
                                instanceId: instanceId
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer002);


/***/ }),

/***/ 14806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grey":"Footer002_grey__7FVEI","dark":"Footer002_dark__hImw0","white":"Footer002_white__coGnN","content":"Footer002_content__1Uqok","title":"Footer002_title__5fzAv","blocks":"Footer002_blocks__H3DzB","manager":"Footer002_manager__1pMDo","image":"Footer002_image__HTkEF","name":"Footer002_name__w88k9","position":"Footer002_position__ox_rG","label":"Footer002_label__eMcAD","phone":"Footer002_phone__0PWVm","application":"Footer002_application__8lqYp"};

/***/ })

}]);